export const product_choose_form = [
    {
        label: "Select a Choice",
        name: "SelectChoice",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: [
                { label: "New Product", value: "newProduct" },
                { label: "Existing Product", value: "existingProduct" },
            ],
        },
    },
];

export const product_choose_form_fields: any = {
    SelectChoice: {
        validators: {
            notEmpty: {
                message: "Option is required",
            },
        },
    },
};

export const product_selection_form = [
    {
        label: "Select Product",
        name: "SelectProduct",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: [],
        },
    },
];

export const product_selection_form_fields: any = {
    SelectProduct: {
        validators: {
            notEmpty: {
                message: "Product is required",
            },
        },
    },
};

export const product_form = [
    {
        label: "Product Name (Displayed in the Label) *",
        name: "productName",
        type: "text-input",
        fieldProps: {
            defaultValue: "",
        },
    },
    {
        label: "Upload product images(recommended: 768x1024) ",
        name: "productImages",
        type: "image-dropzone",
        required: true,
        values: [],
        maxFiles: 3,
        fieldProps: {},
    },
    {
        label: "Description *",
        name: "description",
        type: "ck-editor",
        fieldProps: {},
    },
    {
        label: "Product Video URL(Max upto 5, comma separated)",
        name: "video",
        type: "text-input",
        fieldProps: {
            defaultValue: "",
        },
    },
];

export const product_form_fields = {
    productName: {
        validators: {
            notEmpty: {
                message: "Product name is required",
            },
        },
    },
    description: {
        validators: {
            notEmpty: {
                message: "Product description is required",
            },
        },
    },
    productImages: {
        validators: {
            notEmpty: {
                message: "Product image is required",
            },
        },
    },
};

export const variant_choose_form = [
    {
        label: "Select a Choice",
        name: "SelectChoice1",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: [
                { label: "New Variant", value: "newVariant" },
                { label: "Existing Variant", value: "existingVariant" },
            ],
        },
    },
];

export const variant_choose_form_fields: any = {
    SelectChoice1: {
        validators: {
            notEmpty: {
                message: "Option is required",
            },
        },
    },
};

export const variant_selection_form = [
    {
        label: "Select Product Variant",
        name: "SelectVariant",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: [],
        },
    },
];

export const variant_selection_form_fields: any = {
    SelectVariant: {
        validators: {
            notEmpty: {
                message: "Product is required",
            },
        },
    },
};

export const gtin_form = [
    {
        label: "Barcode (GTIN No. - Can not be edited later) *",
        name: "gtinKey",
        type: "text-input",
        fieldProps: {
            defaultValue: "",
        },
    },
    {
        label: "Description",
        name: "description",
        type: "text-area",
        fieldProps: {},
    },
    {
        label: "Key",
        name: "key1",
        type: "dynamic-field",

        fieldProps: {
            defaultValue: {},
        },
    },
];

export const gtin_form_fields = {
    gtinKey: {
        validators: {
            notEmpty: {
                message: "Barcode (GTIN No.) is required",
            },
        },
    },
};

export const batch_choose_form = [
    {
        label: "Select a Choice",
        name: "SelectChoice2",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: [
                { label: "New Batch", value: "newBatch" },
                { label: "Existing Batch", value: "existingBatch" },
            ],
        },
    },
];

export const batch_choose_form_fields: any = {
    SelectChoice2: {
        validators: {
            notEmpty: {
                message: "Option is required",
            },
        },
    },
};

export const batch_form = [
    {
        label: "Batch No. (Can not be edited later) *",
        name: "batchName",
        type: "text-input",
        fieldProps: {
            defaultValue: "",
        },
    },
    {
        label: "Description ",
        name: "description1",
        type: "text-area",
        fieldProps: {},
    },
];

export const batch_form_fields = {
    batchName: {
        validators: {
            notEmpty: {
                message: "Name is required",
            },
        },
    },
};

export const batch_selection_form = [
    {
        label: "Select Batch",
        name: "SelectBatch",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: [],
        },
    },
];

export const batch_selection_form_fields: any = {
    SelectBatch: {
        validators: {
            notEmpty: {
                message: "Batch is required",
            },
        },
    },
};

export const provenance_form = [
    {
        label: "Provenance Name",
        name: "provenanceName",
        type: "text-input",
        fieldProps: { defaultValue: "" },
    },
    {
        label: "Select Template",
        name: "SelectTemplate",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: [],
        },
    },
];

export const provenance_form_fields = {
    provenanceName: {
        validators: {
            notEmpty: {
                message: "Name is required",
            },
        },
    },
    SelectTemplate: {
        validators: {
            notEmpty: {
                message: "Template is required",
            },
        },
    },
};
